<template>
  <component
    :is="getContainerType"
    v-if="shouldRenderConfig && !getBundleIsActive"
    :class="getClassName"
  >
    <appFragment v-if="getPPMode == 'tabs'">
      <appProductPartsNames
        v-for="(item, index) in getProductPartsNames"
        :key="index"
        :propsData="item"
      >
      </appProductPartsNames>
    </appFragment>
    <appSelectOption
      v-if="getPPMode == 'poptext'"
      :propsData="getProductPartsOption"
      optionType="main"
      :selectId="'select' + 'getPPMode'"
    ></appSelectOption>
  </component>
</template>
<script>
import { mapState, mapActions } from "pinia";

import { useWebproductStore } from "@/stores/modules/webproduct";
import { useConfigStore } from "@/stores/modules/config";
import { useBundleStore } from "@/stores/modules/bundle";

export default {
  computed: {
    ...mapState(useWebproductStore, [
      "getProductPartsNames",
      "getProductPartsOption",
      "getProductPartModeShow"
    ]),
    ...mapState(useConfigStore, ["getShowUpload"]),
    ...mapState(useBundleStore, ["getBundleIsActive"]),
    getPPMode: function () {
      return this.getProductPartModeShow;
    }
  },
  props: ["hideContainer"]
};
</script>
